import React, { useState } from 'react'
import Main from '../../cpn/Main'
import { Button, Form, Input, message } from 'antd'
import { useHangyeTypeAddMutation } from '../../store/dianshangtaizhangApi';

function TradeAdd() {
    const [form] = Form.useForm(); 
    const [submit] = useHangyeTypeAddMutation();
    const [info,setInfo] = useState()
    return (
        <Main selectedKeys={['/TradeAdd']}>
            <Form
                form={form}
                layout="horizonal"
                name="form_client"
                initialValues={{modifier: 'public',}}
                labelCol={{ span: 3 }}   
                onFinish={() => {
                    submit({
                        hyt_name:info.hyt_name,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功！')   
                            form.resetFields();                          
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    }) 
                }}                 
            >                                                       
                <Form.Item name="name" wrapperCol={{span:10}} required label='行业名称'>                        
                    <Input onChange={(e) => {
                        setInfo(prevState=>({...prevState,hyt_name:e.target.value}))
                    }}/>
                </Form.Item>                       
                <Form.Item wrapperCol={{offset:3}} >                        
                    <Button type='primary' htmlType='submit'>提交</Button>
                </Form.Item>
            </Form>
        </Main>
    )
}

export default TradeAdd